import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';

import { TAccount } from './accounts.types';

/**
 * Determines if an account is a funding for a micro loan
 * @param account: TAccount- An Account object
 * @returns true or false
 */
export const getIsMicroLoanFundedAccount = (account: TAccount) => {
    if (!account.account_id || !account.duration) return false;
    return getDurationInMonths(account.duration) <= 6;
};
